module.exports = __webpack_public_path__ + "img/head-banner.6101043c.jpeg";